<template>
  <div class="wrapper">
    <div class="trial" v-show="show">
      <div class="trial__chat" ref="trial-chat">
        <div class="trial__chat--message"
          v-for="(message, index) in messages" :key="index"
          :class="`${message.type === 'admin' ? 'bot-message' : 'user-message'}`"
          :ref="`index-${index}`">
          <div>{{ message.text }}</div>
        </div>
      </div>
    </div>

    <div class="trial__user-input">
      <div v-for="(button, index) in buttons"
          :key="`button-${index}`">
          <div v-if="button.step === messageIndex" @click="button.action"
          class="trial__user-input--button">
            {{ button.text }}</div>
      </div>

      <div class="trial__user-input--input" v-for="(input, index) in inputsToShow"
          :key="`input-${index}`">

             <b-field style="width: 100%;">
            <b-input
              style="width:100%;"
                 :placeholder="input.text" v-model="input.value"
            v-on:keyup.enter="input.action(input)">
            </b-input>
            <div class="trial__user-input--input-button" @click="input.action(input)">
              <font-awesome-icon style="margin: 10px;" color="#abaeb1"
                size="lg" :icon="['fas', 'paper-plane']" />
            </div>
        </b-field>
            <!-- <span>Send</span> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */

import { mapActions, mapState } from 'vuex';
import { pushToFirebase } from '../../mixins/firebase';

export default {
  data() {
    return {
      messages: [],
      userName: 'user',
      botNick: 'Wojtek',
      messageIndex: 0,
      botMessegeIndex: 0,
      buttons: [],
      inputs: [],
      show: false,
      translationPath: 'trial',
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
      this.firstStep();
    }, 1000);
  },
  computed: {
    ...mapState({
      nick: (state) => state.userStore.nick,
    }),
    buttonsForStep() {
      return this.buttons.filter((button) => button.step === this.messageIndex);
    },
    inputsToShow() {
      return this.inputs.filter((input) => input.step === this.messageIndex);
    },
  },
  methods: {
    ...mapActions({
      updateNick: 'userStore/updateNick',
    }),
    addMessage(message, nick, type) {
      const messageObject = { text: message, nick, type };
      this.messages.push(messageObject);
      this.nextStep();
      this.scrollChatToDown();
    },
    async addBotMessage(timeout, message, callback) {
      await setTimeout(() => {
        this.addMessage(message, this.botNick, 'admin');
        this.botMessegeIndex += 1;
        if (callback) callback();
      }, timeout);
    },
    addButton(message, callback) {
      this.buttons.push({
        text: message,
        action: callback,
        step: this.messageIndex,
      });
    },
    addInput(message, callback) {
      this.inputs.push({
        text: message,
        action: callback,
        step: this.messageIndex,
        value: '',
      });
    },
    nextStep() {
      this.messageIndex += 1;
    },
    scrollChatToDown() {
      const content = this.$refs;
      setTimeout(() => {
        if (content['trial-chat']) content['trial-chat'].scrollTop = content['trial-chat'].scrollHeight;
      }, 1);
    },
    async firstStep() {
      await this.addBotMessage(1000, this.$t(`${this.translationPath}.welcomeInBrand`));
      await this.addBotMessage(2000, this.$t(`${this.translationPath}.setNick`),
        () => this.addInput(this.$t(`${this.translationPath}.setingNick`), this.enterName));
    },
    enterName(input) {
      if (input.value.length > 20) return alert(this.$t(`${this.translationPath}.toLongNick`));
      if (input.value.length < 5) return alert(this.$t(`${this.translationPath}.toShortNick`));
      if (!input.value.match(/^[a-zA-Z0-9]+$/)) return alert(this.$t(`${this.translationPath}.onlyLettersAndNumbers`));
      this.addMessage(input.value, this.userName, 'user');
      this.updateNick(input.value);
      setTimeout(() => {
        this.addBotMessage(100, `${this.$t(`${this.translationPath}.hello`)} ${input.value}, ${this.$t(`${this.translationPath}.wellcomeMessage`)}`);
        // eslint-disable-next-line max-len
        // this.addBotMessage(100, `Cześć ${input.value}, miło mi cię poznać. Przenoszę Cię do apki.)`);
        this.secondStep();
        return null;
      }, 1500);
      return null;
    },
    async secondStep() {
      await this.addBotMessage(1000, this.$t(`${this.translationPath}.yourFirstTime`));
      await this.addBotMessage(3000, this.$t(`${this.translationPath}.canItakeYouMinutes`), () => {
        this.addButton(this.$t(`${this.translationPath}.letsStart`), this.thirdStep);
        this.addButton(this.$t(`${this.translationPath}.skipTrial`), this.skipTrial);
      });
    },
    async skipTrial() {
      await this.addBotMessage(500, this.$t(`${this.translationPath}.afterSkipTrialMessage`));
      setTimeout(() => {
        this.$router.push({ path: 'HabitsDashboard' });
      }, 2000);
    },
    async thirdStep() {
      this.addMessage(this.$t(`${this.translationPath}.letsStart`), this.userName, 'user');
      await this.addBotMessage(2000, this.$t(`${this.translationPath}.thirdStep1`));
      await this.addBotMessage(4000, this.$t(`${this.translationPath}.thirsStep2`));
      await this.addBotMessage(6000, this.$t(`${this.translationPath}.thirdStep3`));
      await this.addBotMessage(10000, this.$t(`${this.translationPath}.thirsStep4`));
      await this.addBotMessage(14000, this.$t(`${this.translationPath}.thirdStep5`));
      await this.addBotMessage(18000, this.$t(`${this.translationPath}.thirsStep6`));
      await this.addBotMessage(22000, this.$t(`${this.translationPath}.thirdStep7`),
        () => this.addInput(this.$t(`${this.translationPath}.thirdStep8`), this.enterhabit));
    },
    enterhabit(input) {
      this.addMessage(input.value, this.userName, 'user');
      this.createhabit(input.value);
    },
    async createhabit(name) {
      const habitToCreated = {
        localId: this.$uniqueId(),
        name,
        created: this.$moment().toISOString(),
        isActive: true,
        time: this.$moment().format('HHmm'),
      };
      await this.addBotMessage(4000, this.$t(`${this.translationPath}.weAddYourHabit`));
      this.addActivityHabits(habitToCreated);
      setTimeout(() => {
        this.$router.push({ path: 'HabitsDashboard' });
      }, 6000);
    },
    addActivityHabits(habitToCreated) {
      // to powinno być akcja ze store TODO
      pushToFirebase('activityHabits', habitToCreated);
    },
  },
};
</script>

<style lang="scss" scoped>
  .wrapper {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: $background-light-color;
  }
  .trial {
    &__chat {
      width: 100%;
      padding: 20px;
      height: 80vh;
      overflow-y: auto;
      display: flex;
      flex-flow: column wrap;
      flex-wrap: nowrap;

      &--message {
        font-weight: 500;
        border-radius: 1em;
        padding: 0.8em 0.8em;
        margin: 0.0825em;
        max-width: 70vw;
        font-size: 1rem;
        font-family: Avenir, Arial, sans-serif;
        line-height: 1.25;
      }

      .bot-message {
        background-color: $brand;
        border-bottom-right-radius: 0.1em;
        align-self: flex-start;
      }
      .user-message {
        background-color: cornflowerblue;
        color: #fff;
        border-bottom-left-radius: 0.1em;
        align-self: flex-end;
      }
    }
  &__user-input {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;

    &--button {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 10px 20px;
      margin: 10px;
      background: $background-light-color;
      color: $font-dark-color;
      border: 1px solid black;
      height: 50px;
    }
    &--input {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      ::v-deep input  {
        background: $brand;
        border: none;
        height: 60px;
      }
      ::v-deep input:active, input:hover input:focus  {
        border: none;
      }
    }
    &--input-button {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: $brand;
      padding-right: 10px;
    }
    span {
      position: absolute;
      right: 0;
      top: 0;
      background: red;
      padding: 10px;
    }
    input {
      margin: 1rem;
      border: 0;
      padding: 7px;
      width: 100%;
      background: $brand;
      height: 40px;
      // color: $font-dark-color;
    }
  }
}
</style>
